<template>
  <v-app id="inspire">
    <AccountHeader :userData="userData" />
    <div class="home-container">
      <SimpleFlexRow :classes="{ 'base-row': true, 'nowrap': true }">
        <SimpleFlexColumn :classes="{ 'drawer-container': true }">
          <div class="drawer" v-if="!communityManagerScreen">
            <div class="pic">
              <router-link to="/profile/edit"><img :src="(userData.profile && userData.profile.pic )? userData.profile.pic : '/static/communities/user-no-pic.png'" /></router-link>
              <div class="user-title">
                <h2>{{ userData.username || "User" }}</h2>
                <router-link to="/profile/edit">Edit Profile</router-link>
              </div>
            </div>

            <div class="menu">
              <MenuItem icon="/static/icons/home.png" label="Your StoryFaith" link="/" />
              <MenuItem v-if="demo" icon="/static/icons/face.png" label="People"  link="/people" />
              <MenuItem icon="/static/icons/calendar.png" label="Events" link="/events" />
              <MenuItem v-if="demo" icon="/static/icons/book.png" label="Courses" link="/courses" />
              <MenuItem icon="/static/icons/logout.png" label="Log Out" link="/logout" />
            </div>

          </div>
          <div class="drawer" v-if="communityManagerScreen">
            <router-link class="sf-manager-exit" to="/communities">
              ← My communities
            </router-link>
            <div class="pic">
              <img :src="pic? pic : '/static/communities/user-no-pic.png'" />
              <div class="community-title">
                <h2>{{ name? name : "Community"}}</h2>
                <a target="_blank" :href="link">Open community page</a>
              </div>
            </div>
            <div class="menu">
              <MenuItem v-if="demo && teamRole !== 'host'" icon="/static/icons/home.png" label="Dashboard" :link="'/community-manager/' + communitySlug + '/dashboard'" />
              <MenuItem v-if="teamRole === 'owner' || teamRole === 'admin'" icon="/static/icons/community.png" label="Overview" :link="'/community-manager/' + communitySlug + '/overview'" />
              <MenuItem v-if="teamRole === 'owner' || teamRole === 'admin'" icon="/static/icons/book.png" label="Rhythms" :link="'/community-manager/' + communitySlug + '/rhythms'" />
              <MenuItem v-if="teamRole === 'owner' || teamRole === 'admin'" icon="/static/icons/forms.png" label="Customize Forms" :link="'/community-manager/' + communitySlug + '/forms'" />
              <MenuItem v-if="teamRole === 'owner' || teamRole === 'admin'" icon="/static/icons/calendar.png" label="Manage Events" :link="'/community-manager/' + communitySlug + '/events'" />
              <MenuItem v-if="teamRole === 'owner' || teamRole === 'admin'" icon="/static/icons/forms.png" label="AI Transcriber" :link="'/community-manager/' + communitySlug + '/ai-transcriber'" />
              <MenuItem icon="/static/icons/community.png" label="Team" :link="'/community-manager/' + communitySlug + '/team'" />
              <MenuItem icon="/static/icons/logout.png" label="Log Out" link="/logout" />
            </div>
          </div>
        </SimpleFlexColumn>
        <SimpleFlexColumn :classes="{ 'content': true }" >
          <!-- Content -->
          <router-view
            @set-pic-name="setPicName"
            @account-updated="syncAccount"
            @team-role="teamRole = $event"
          ></router-view>

        </SimpleFlexColumn>
      </SimpleFlexRow>
    </div>
  </v-app>
</template>
<script>
// Fetch compatibility
import 'whatwg-fetch'
import MenuItem from '../components/MenuItem.vue'
import AccountHeader from './AccountHeader.vue'
import SimpleFlexRow from '../components/SimpleFlexRow.vue'
import SimpleFlexColumn from '../components/SimpleFlexColumn.vue'


export default {
  name: 'Home',
  components: {
    MenuItem, SimpleFlexRow, SimpleFlexColumn, AccountHeader
  },
  props: {
    userData: Object
  },
  data () {
    return {
      contentTitle: "",
      demo: false,
      pic: null,
      name: null,
      communitySlug: null,
      teamRole: null,
      user: {
        profile: {
          location: "",
          pic: null,
          description: "",
          community_favs: []
        },
        username: null,
        badges: [],
        my_communities: [],
      },
      communityManagerScreen: false,
    }
  },
  computed: {
    link() {
      if (this.$route.path.startsWith('/community-manager/')) {
        return '/' + this.$route.params.slug + '/'
      }
      return ''
    }
  },
  methods: {
    syncAccount (data) {
      Object.keys(data).forEach(key => this.$set(this.userData, key, data[key]))
    },
    async handleRoute (route) {
      if (route.path.startsWith('/community-manager/')) {
        if (this.communitySlug !== route.params.slug) this.teamRole = null
        this.communityManagerScreen = true
        this.communitySlug = route.params.slug
      }
      else {
        this.communityManagerScreen = false
      }
    },
    setPicName (pic, name) {
      this.pic = pic
      this.name = name
    }
  },
  watch: {
    $route (to) {
      this.handleRoute(to)
    }
  },
  beforeDestroy () {
    document.body.classList.remove('sf-account-shell')
  },
  created () {
    let header = document.getElementById("header")
    if (header) header.classList.add("navbar-home")
    document.body.classList.add('sf-account-shell')
    this.handleRoute(this.$route)

  }
}
</script>
<style>
.home-container {
  position: relative;
}
.drawer-container {
  background: #222222;
  max-width: 280px;
  padding: 0px 30px;
  padding-right: 10px;
}
.base-row {
  min-height: 100vh;
}
.pic img {
  width: 55px;
  height: 55px;
  object-fit: cover;
  border-radius: 150px;
  background: #999;
  float:left;
}
.pic .user-title, .pic .community-title {
  margin-left: 70px;
  color: white;
  font-weight: bold;
}
.user-title h2 {
  font-size: 22px;
  font-weight: bold;
}
.community-title h2 {
  font-size: 20px;
  font-weight: bold;
  padding-top: 10px;
}
.user-title a {
  text-decoration: underline;
  font-weight: normal;
}
.pic {
  margin-top: 20px;
  min-height: 62px;
}
.menu {
  margin-top: 40px;
}
.menu-item {
  color: white;
}
.home-container .content {
  margin: 0;
  padding-left: 20px;
  max-width: 1400px;
  min-width: 0;
}
.home-container .content .container-fluid {
  padding: 0px;
}

@media (max-width: 900px) {
  .drawer-container {
    max-width: 40px;
    padding: 0px 10px;
  }
  .pic {
    display: none;
  }
}

@media (max-width: 500px) {
  .home-container .content {
    padding: 10px 0px 0px 10px;
  }
  .container-fluid {
    padding-left: 5px;
  }
  .main-content .content{
    padding-left: 7px;
  }
}

.v-application a {
  color: inherit !important;
}

a {
  color: inherit;
  text-decoration: inherit;
  cursor: pointer;
}


/* Signed-in account navigation */
body.sf-account-shell > header { display: none; }
.sf-manager-exit {
  display: block; padding: 18px 0 12px; color: #fff;
  font-size: 13px; border-bottom: 1px solid #ffffff24;
}
.sf-manager-exit:focus-visible { outline: 3px solid #ffd400; outline-offset: 3px; }
@media (max-width: 900px) {
  .sf-manager-exit { font-size: 11px; overflow-wrap: anywhere; }
}


/* Readable manager exit */
.v-application .sf-manager-exit {
  color: #fff !important;
}

</style>
